import { jsx as _jsx } from "react/jsx-runtime";
import * as ToastPrimitive from '@radix-ui/react-toast';
import { Button } from '../../index.js';
export const ToastAction = ({ children, altText, ...otherProps }) => (_jsx(ToastPrimitive.Action, { asChild: true, altText: altText, children: _jsx(Button, { ...otherProps, dimension: "small", children: children }) }));
